import {Injectable} from '@angular/core';
import * as globals from '../settings';
import {LotteriesService} from '../lotteries.service';
import {UserService} from '../_services/user.service';
import {LoginService} from './navigation/login.service';
// import {PaystackSupportService} from './paystack-support.service';


@Injectable({
    providedIn: 'root'
})
export class RestartOrderService {
    user: any;

    constructor(public lotteryService: LotteriesService, public userService: UserService, public loginService: LoginService) {
    }

    restartOrder() {
        if (this.userService && this.userService.userData && this.userService.userData.sessionId) {
            this.lotteryService.postData
            (`${globals.appDomain}/cart/restartOrder/restartOrder_service.json`,
                this.lotteryService.getFormUrlEncoded({'sessionId': this.userService.userData.sessionId}))
                .subscribe(
                    result => {
                        // console.log(result);
                        // console.log('get cart for debug reasnons');
                        // this.prepareOrder();
                        // this.paystackSupport2.generateReferenceId();
                    }
                );
        }
    }

    prepareOrder() {
        this.user = this.userService.userData;
        const sendData = {};
        sendData['sessionId'] = this.user.sessionId;
        this.lotteryService
            .postData(
                globals.appDomain + '/cart/get/' + this.user.MemberID + '/CartGet.json', this.loginService.getFormUrlEncoded(sendData))
            .subscribe(
                data => {
                    // console.log(data);
                }
            );
    }
}
